import request from '@/utils/request'
/**
 * @apiName 获取应收变更列表
 * @apiUrl
 */
export function getAccruedChangeList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedChange/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 批量收款中根据customerId查询账户信息
 * @apiUrl
 */
export function getAccountDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/account/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 批量付款中根据customerId查询账户信息
 * @apiUrl
 */
export function getAccountDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/account/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 财务类目根据支付内容查询 筛选时默认选中使用
 * @apiUrl
 */
export function getFindByFundType(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/category/findByFundType',
    method: 'POST',
    data,
  })
}

